export default __webpack_public_path__ + "static/media/Monk's Jerkin of the Sacred Mountain.6a0d5bbd.jpg";